import React from 'react';
import cx from 'classnames';
import ReactMarkdown from 'react-markdown';

import rehypeRaw from 'rehype-raw';
import renderers from './renderers';

import styles from './MarkdownWrapper.module.less';

type MarkdownWrapperProps = {
  source: string | undefined;
  styleOverride?: string;
};

const getLinkTarget = (url: string): string => {
  return url?.slice(0, 1) === '#' ? '_self' : '_blank';
};

const MarkdownWrapper: React.FC<MarkdownWrapperProps> = ({ source, styleOverride }) => {
  return (
    <ReactMarkdown
      className={cx(styles.markdown, styleOverride)}
      components={renderers}
      linkTarget={getLinkTarget}
      rehypePlugins={[rehypeRaw]}
    >
      {source || ''}
    </ReactMarkdown>
  );
};

export default MarkdownWrapper;
